export default {"src":"/_next/static/media/empty-star.bc053feb.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};